const PAGINATION = {
  OFFSET: 0,
  LIMIT: 1000,
};

export default {
  PAGINATION,
} as const;
